import { render, staticRenderFns } from "./nurole-podcast-enter-the-boardroom.vue?vue&type=template&id=fd60a0e4"
import script from "./nurole-podcast-enter-the-boardroom.vue?vue&type=script&lang=js"
export * from "./nurole-podcast-enter-the-boardroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingPage: require('/home/runner/work/marketing/marketing/components/LandingPage.vue').default})
